$dependencyManager.addDependenciesCallback(['gsap', 'scrollTrigger'], () => {
  gsap.registerPlugin(ScrollTrigger);
  jQuery(document).ready(($) => {
    addButtonClickEvents();
    addButtonScrollEvents();

    function addButtonClickEvents() {
      if (!jQuery('.mad-single-product-content__buttons-container').length) return;

      let isAnimating = false; // Flag to track if animation is running

      // Stop animation if the user scrolls manually
      jQuery(window).on('wheel touchmove keydown', function () {
        if (isAnimating) {
          jQuery('html, body').stop(true, false);
          isAnimating = false;
        }
      });

      jQuery('.mad-single-product-content__button').each(function () {
        const $btn = jQuery(this);
        const sectionId = $btn.attr('data-content-section');
        const href = $btn.attr('href');
        let targetByHref = false;

        if (href) {
          try {
            let selector = href;
            if (window.CSS && CSS.escape && href.charAt(0) === '#') {
              selector = '#' + CSS.escape(href.substring(1));
            }
            targetByHref = jQuery(selector).length > 0;
          } catch (e) {
            targetByHref = false;
          }
        }

        // Only attach handler if there's no valid href target
        if (!targetByHref) {
          $btn.on('click', function (e) {
            e.preventDefault();

            const targetSection = jQuery('.mad-single-product-content__section[data-content-section="' + sectionId + '"]');
            let navbarHeight = jQuery('.mad-navbar__section').outerHeight() || 0;
            let navbarPosition = jQuery('.mad-navbar__section').length ? jQuery('.mad-navbar__section').position().top || 0 : 0;

            let scrollOffset = navbarPosition + navbarHeight;

            if (jQuery('#wpadminbar').length > 0) {
              scrollOffset += jQuery('#wpadminbar').height();
            }

            let contentButtonsHeight = jQuery('.mad-single-product-content__buttons-container').outerHeight() || 0;
            scrollOffset += contentButtonsHeight;

            let padding = window.$madSettings.shop.single_product_content_buttons_padding || 0;
            scrollOffset += padding;

            if (targetSection.length) {
              isAnimating = true;
              jQuery('html, body').animate(
                {
                  scrollTop: targetSection.offset().top - scrollOffset,
                },
                500,
                function () {
                  isAnimating = false;
                }
              );
            }
          });
        }
      });
    }

    function addButtonScrollEvents() {
      if (!jQuery('.mad-single-product-content__buttons-container').length) return;

      // --- compute the same offset you used for the pin "start"
      const computeStickyTop = () => {
        let navbarHeight = jQuery('.mad-navbar__section').outerHeight() || 0;
        let navbarPosition = jQuery('.mad-navbar__section').length ? (jQuery('.mad-navbar__section').position().top || 0) : 0;
        let top = navbarPosition + navbarHeight;

        if (jQuery('#wpadminbar').length) {
          top += jQuery('#wpadminbar').outerHeight() || 0;
        }

        let padding = window.$madSettings?.shop?.single_product_content_buttons_padding
          ? parseInt(window.$madSettings.shop.single_product_content_buttons_padding)
          : 0;

        // keep the original "-1" nudge to mirror ScrollTrigger start precisely
        return top + padding - 1;
      };

      // --- enable sticky positioning
      const $container = jQuery('.mad-single-product-content__buttons-container');
      const $bg = jQuery('.mad-single-product-content__buttons-bg');

      const applyStickyTop = () => {
        const topVal = computeStickyTop();
        $container.css({
          position: 'sticky',
          top: `${topVal}px`,
          zIndex: 5
        });
      };

      applyStickyTop();

      // --- fade-out effect at the end of content (keep from old code)
      gsap.to('.mad-single-product-content__buttons-container', {
        scrollTrigger: {
          trigger: '.mad-single-product-content__container',
          start: () => 'bottom top',
          end: () => 'bottom top',
          toggleActions: 'play none none reverse',
        },
        opacity: 0,
        duration: 0.3
      });

      // --- active button update logic (unchanged)
      const findSectionClosestToViewportTop = () => {
        let minDistanceToTop = Infinity;
        let closestSection = null;

        // calculate offset: #wpadminbar + .mad-navbar__section (if present)
        let offset = 0;
        if (jQuery('#wpadminbar').length) {
          offset += jQuery('#wpadminbar').outerHeight() || 0;
        }
        if (jQuery('.mad-navbar__section').length) {
          offset += jQuery('.mad-navbar__section').outerHeight() || 0;
        }

        const scrollTop = jQuery(window).scrollTop();

        jQuery('.mad-single-product-content__section').each(function () {
          const $section = jQuery(this);
          const sectionTop = $section.offset().top;
          const distanceToTop = Math.abs((scrollTop + offset) - sectionTop);

        if (distanceToTop < minDistanceToTop) {
            minDistanceToTop = distanceToTop;
            closestSection = $section;
          }
        });

        return closestSection;
      };

      const updateActiveButton = () => {
        const section = findSectionClosestToViewportTop();
        jQuery('.mad-single-product-content__button').removeClass('active');

        if (section) {
          const sectionId = section.attr('data-content-section');
          jQuery(`.mad-single-product-content__button[data-content-section="${sectionId}"]`).addClass('active');
        }
      };

      jQuery(window).on('scroll', updateActiveButton);

      // --- helper: width when sticky vs. non-sticky
      const getTargetWidth = () => {
        const $row = jQuery('.mad-navbar').closest('.brz-row');
        const w = $row.length ? $row.outerWidth() : $container.outerWidth();
        return w || jQuery(window).width();
      };

      // NEW: width of the nearest ancestor <section> when NOT sticky
      const getSectionWidth = () => {
        const $sec = $container.closest('section');
        const w = $sec.length ? $sec.outerWidth() : $container.outerWidth();
        return w || jQuery(window).width();
      };

      let wasStickyActive = null;

      const updateStickyStateAndBG = () => {
        const topVal = computeStickyTop();
        $container.css('top', `${topVal}px`);

        const scrollTop = jQuery(window).scrollTop() || 0;
        const containerTop = $container.offset().top || 0;
        const isStickyActive = (scrollTop + topVal) >= containerTop;

        if (wasStickyActive === isStickyActive) return;

        wasStickyActive = isStickyActive;

        if (isStickyActive) {
          // Sticky ON → shrink to row width and apply frame styles
          gsap.to($bg, {
            width: getTargetWidth(),
            borderRadius: 'var(--background-border-radius)',
            border: 'var(--background-border)',
            boxShadow: 'var(--background-box-shadow)',
            duration: 0.35,
            overwrite: true
          });
        } else {
          // Sticky OFF → set width to ancestor <section> width (instead of 100vw)
          gsap.to($bg, {
            width: getSectionWidth(),
            borderRadius: 0,
            border: 'none',
            boxShadow: 'none',
            duration: 0.35,
            overwrite: true
          });
        }
      };

      // initial run
      updateStickyStateAndBG();

      // --- debounce helper
      const debounce = (fn, wait) => {
        let t;
        return function () {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, arguments), wait);
        };
      };

      // --- Resize handling with smart recalculation ---
      const handleResize = () => {
        applyStickyTop();

        // if sticky active, recalc width dynamically; non-sticky width stays section-based
        if (wasStickyActive) {
          gsap.set($bg, { width: getTargetWidth() });
        }

        updateStickyStateAndBG();
      };

      jQuery(window).on('scroll', updateStickyStateAndBG);
      jQuery(window).on('resize orientationchange', debounce(handleResize, 150));

      // Observe navbar/adminbar size changes to update top value dynamically
      const observeIfPresent = (el) => {
        if (!el || !el.length || !('ResizeObserver' in window)) return;
        const ro = new ResizeObserver(() => {
          handleResize();
        });
        ro.observe(el.get(0));
      };
      observeIfPresent(jQuery('#wpadminbar'));
      observeIfPresent(jQuery('.mad-navbar__section'));
    }

    // --- Flex alignment based on overflow ---
    function updateButtonsJustify() {
      const $buttons = jQuery('.mad-single-product-content__buttons');
      const $wrapper = jQuery('.mad-single-product-content__buttons-wrapper');
      if (!$buttons.length || !$wrapper.length) return;

      // Sum up total width of all buttons (including margins)
      let totalButtonsWidth = 0;
      $buttons.children().each(function () {
        totalButtonsWidth += jQuery(this).outerWidth(true);
      });

      const screenWidth = jQuery(window).width();

      if (totalButtonsWidth > screenWidth) {
        $buttons.css('justify-content', 'flex-start');
        $wrapper.css('overflow-x', 'scroll');
      } else {
        $buttons.css('justify-content', '');
        $wrapper.css('overflow-x', '');
      }
    }

    function debounce(fn, wait) {
      let t;
      return function () {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, arguments), wait);
      };
    }

    updateButtonsJustify();
    jQuery(window).on('load', updateButtonsJustify);
    jQuery(window).on('resize orientationchange', debounce(updateButtonsJustify, 150));
  });
});
